// extracted by mini-css-extract-plugin
export default {"link":"S3GaTj","image":"bHLGFC","root":"ROb7KR"};